<template>
  <div class="product-detail-page-1">
    <!-- 商品总的描述 -->
    <div class="top-section flex-between">
      <!-- 左边主要内容 -->
      <div class="left-content flex-rowl">
        <div class="image-container">
          <img
            src="https://upload.vwingist.com/melscn/0image/2025/10/5744493551731885948.jpg?v=01"
            class="zoomable-image"
          />
        </div>
        <div class="text-content">
          <h1 class="title">{{ $t('productDetail1.title') }}</h1>
          <h2 class="sub_title">{{ $t('productDetail1.subTitle') }}</h2>
          <div class="description">
            <p class="txt1 mb_30">{{ $t('productDetail1.description.para1') }}</p>
            <p class="txt2 mb_40">{{ $t('productDetail1.description.para2') }}</p>
            <p class="txt1 mb_30">{{ $t('productDetail1.description.para3') }}</p>
            <p class="txt2 mb_40">{{ $t('productDetail1.description.para4') }}</p>
            <p class="txt1 mb_30">{{ $t('productDetail1.description.usageTitle') }}</p>
            <p class="txt2" v-html="$t('productDetail1.description.usageContent')"></p>
          </div>
          <div
            class="more-details-wrap"
            @mouseenter="showQRCode = true"
            @mouseleave="showQRCode = false"
          >
            <button class="more-details-btn flex-rowl">
               {{ $t('productDetail1.consultationButton') }}
              <i class="iconfont icon-xiangxiajiantou"></i>
            </button>
            <div class="more-details-ercode flex-colc" v-show="showQRCode">
              <div class="ercode_img">
                <img
                  src="https://upload.vwingist.com/melscn/0image/2025/05/5234229175950700963.png"
                  alt=""
                />
              </div>
              <div class="ercode_txt flex-colc">
                <p v-html="$t('productDetail1.qrCodeInfo.text1')"></p>
                <p v-html="$t('productDetail1.qrCodeInfo.text2')"></p>
                <p>{{ $t('productDetail1.qrCodeInfo.text3') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右边商品分类折叠面板 -->
      <ProductCategoryPanel />
    </div>
    <!-- 商品详细描述 -->
    <div class="bottom-section">
      <div
        v-for="(item, index) in detailItems"
        :key="index"
        :class="[
          'bottom-section-list flex-between',
          item.length == 2 ? 'new-class-2' : '',
          item.length == 3 ? 'new-class-3' : '',
        ]"
      >
        <div
          class="detail-item"
          v-for="(itemChild, indexChild) in item"
          :key="indexChild"
        >
          <div class="top-part flex-between">
            <div class="left-text">
              <h2 class="sub-title">{{ $t(`productDetail1.detailItems[${index}][${indexChild}].subTitle`) }}</h2>
              <p class="sub-description">{{ $t(`productDetail1.detailItems[${index}][${indexChild}].subDescription`) }}</p>
            </div>
            <div class="right-image image-container">
              <img :src="itemChild.imageUrl" class="zoomable-image" />
            </div>
          </div>
          <div class="bottom-part">
            <h3 class="detail-title" v-html="$t(`productDetail1.detailItems[${index}][${indexChild}].detailTitle`)"></h3>
            <p class="detail-description" v-html="$t(`productDetail1.detailItems[${index}][${indexChild}].detailDescription`)"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductCategoryPanel from "@/components/ProductCategoryPanel.vue";

export default {
  name: "ProductDetail1",
  components: {
    ProductCategoryPanel,
  },
  data() {
    return {
      showQRCode: false,
      detailItems: [
        [
          {
            subTitle: "膠原蛋白",
            subDescription: "肌膚的青春源泉",
            imageUrl:
              "https://upload.vwingist.com/melscn/0image/2025/03/5126805033588813043.png",
            detailTitle: "面膜中富含的膠原蛋白，<br/>是肌膚保持年輕的秘密",
            detailDescription:
              "它深入肌膚底層，活化細胞活力，讓肌膚恢復彈性，重現18歲的光彩。<br/><br/> 膠原蛋白不僅能保濕，還能緊緻肌膚，減少鬆弛，讓輪廓更加清晰，重現緊緻有彈性的年輕狀態。<br/><br/> 同時，它還能增強肌膚的自我修復能力，修復受損的肌膚屏障，讓肌膚更健康、更有抵抗力。",
          },
          {
            subTitle: "水潤力量",
            subDescription: "肌膚的瀑布",
            imageUrl:
              "https://upload.vwingist.com/melscn/0image/2025/03/4937274906425860334.png",
            detailTitle:
              "VESCOR面膜帶著瑞士山泉的<br/>清新，為肌膚一場水潤的瀑布浴",
            detailDescription:
              "玻尿酸精華讓肌膚喝飽水，光滑得像剝了殼的雞蛋。玻尿酸能夠鎖住水分，形成保濕屏障，讓肌膚敷完面膜後仍能維持24小時的水潤狀態。<br/><br/>我們也特別添加了瑞士冰川水，富含天然礦物質和微量元素，為肌膚帶來深層滋養，讓肌膚從內而外煥發光彩。",
          },
          {
            subTitle: "植物精華",
            subDescription: "肌膚的溫柔鄉",
            imageUrl:
              "https://upload.vwingist.com/melscn/0image/2025/03/4662195759536696918.png",
            detailTitle: "積雪草、紫松果菊等植物精華，<br>是肌膚的溫柔守護者",
            detailDescription:
              "它們輕聲細語地撫慰肌膚，讓肌膚在享受清潔的同時，也能感受到溫柔的擁抱。 <br/><br/>這些植物精華具有天然的舒緩功效，能够緩解肌膚的敏感和不適，讓敏感肌也能安心使用。<br/><br/>積雪草被譽為“天然修復劑”，能够促進膠原蛋白合成，修復受損的肌膚細胞，讓肌膚恢復健康狀態。",
          },
        ],
        [
          {
            subTitle: "360°貼合",
            subDescription: "完美貼合每吋肌膚",
            imageUrl:
              "https://upload.vwingist.com/melscn/0image/2025/03/5047973923162834408.png",
            detailTitle: "面膜設計完美貼合臉部輪廓",
            detailDescription:
              "確保每一滴精華都能被肌膚完全吸收，不浪費一滴。採用先進的超薄面膜紙技術，厚度僅為傳統面膜的1/3，輕薄到幾乎讓人忘卻它的存在。<br/><br/>敷上瞬間，彷彿為肌膚披上了一層透明的保護膜，透氣又服帖，讓你在享受滋養的同時，也能自由呼吸。因為超薄，所以比較貼合；因為貼合，所以更有效率。",
          },
          {
            subTitle: "天然香氛",
            subDescription: "沉浸式瑞士之旅",
            imageUrl:
              "https://upload.vwingist.com/melscn/0image/2025/03/5376103613163479484.png",
            detailTitle: "打開面膜的那一刻，彷彿置身於瑞士的阿爾卑斯山腳下",
            detailDescription:
              "我們特別調配了天然植物香氛，融合了瑞士松樹的清新、阿爾卑斯草甸的芬芳和一絲薄荷的清涼，讓你在敷面膜的20分鐘裡，彷彿真的在瑞士度假，身心得到徹底放鬆。",
          },
        ],
      ],
    };
  },
};
</script>

<style scoped lang="less">
.product-detail-page-1 {
  .image-container {
    display: inline-block; /* 确保容器只占用图片的空间 */
    overflow: hidden; /* 隐藏超出容器的部分 */
  }
  .zoomable-image {
    transition: transform 0.3s ease; /* 添加过渡效果，使放大过程更平滑 */
    cursor: pointer;
    &:hover {
      transform: scale(1.07); /* 鼠标悬停时放大图片 */
    }
  }
  .top-section {
    margin-bottom: 120px;
    align-items: flex-start;
    .left-content {
      width: 985px;
      flex-shrink: 0;
      align-items: flex-start;
      .image-container {
        width: 389px;
        height: 613px;
        margin-right: 50px;
        img {
          width: 100%;
          height: auto;
        }
      }
      .text-content {
        flex: 1;
        color: #333333;
        .title {
          font-size: 26px;
          margin-bottom: 10px;
          font-family: "SourceHanSerifCN-Medium", sans-serif;
          font-weight: 600;
        }
        .sub_title {
          font-size: 24px;
          margin-bottom: 40px;
        }

        .description {
          .txt1 {
            font-size: 20px;
            font-family: "SourceHanSerifCN-Medium", sans-serif;
          }
          .txt2 {
            font-size: 18px;
            line-height: 30px;
            font-family: "SourceHanSerifCN-Light", sans-serif;
          }
          .mb_30 {
            margin-bottom: 30px;
          }
          .mb_40 {
            margin-bottom: 40px;
          }
        }

        .more-details-btn {
          width: 359px;
          height: 50px;
          border-radius: 0px 0px 0px 0px;
          border: 2px solid #000000;
          font-size: 16px;
          color: #000000;
          margin-top: 50px;
          cursor: pointer;
          position: relative;
          padding-left: 30px;
          box-sizing: border-box;
          background-color: #fff;
          .icon-xiangxiajiantou {
            position: absolute;
            right: 20px;
            font-size: 12px;
          }
        }
      }
    }
  }

  .bottom-section {
    .bottom-section-list {
      align-items: flex-start;
      &.new-class-2 {
        padding-left: 110px;
        padding-right: 110px;
        .detail-item {
          flex-shrink: 0;
          width: calc((100% - 100px) / 2);
        }
      }
      &.new-class-3 {
        margin-bottom: 100px;
        .detail-item {
          flex-shrink: 0;
          width: calc((100% - 100px) / 3);
        }
      }
      .detail-item {
        padding-right: 47px;
        box-sizing: border-box;
        border-right: 1px dashed #999999;
        &:last-child {
          border-right: none;
        }
        .top-part {
          width: 370px;
          height: 150px;
          background: #f9f9f9;
          box-shadow: inset 0px 0px 16px 1px rgba(84, 79, 90, 0.1);
          border-radius: 75px 75px 75px 75px;
          margin-bottom: 50px;
          padding: 0 2px 0 27px;
          box-sizing: border-box;
          .left-text {
            color: #333333;
            flex: 1;
            .sub-title {
              font-size: 30px;
              font-family: "SourceHanSerifCN-Medium", sans-serif;
              margin-bottom: 10px;
              font-weight: 600;
            }
            .sub-description {
              font-size: 24px;
              font-family: "SourceHanSerifCN-Medium", sans-serif;
            }
          }
          .right-image {
            width: 145px;
            height: 145px;
            border: 5px solid #fff;
            border-radius: 50%;
            box-sizing: border-box;
          }
        }
        .bottom-part {
          color: #333333;
          .detail-title {
            font-size: 24px;
            line-height: 34px;
            margin-bottom: 30px;
            font-family: "SourceHanSerifCN-Medium", sans-serif;
          }
          .detail-description {
            font-size: 16px;
            line-height: 28px;
            font-family: "SourceHanSerifCN-Light", sans-serif;
          }
        }
      }
    }
  }
  .more-details-wrap {
    position: relative;
    .more-details-ercode {
      width: 378px;
      height: 408px;
      background: url(https://upload.vwingist.com/melscn/0image/2025/04/5425508493632964248.png)
        no-repeat center;
      background-size: cover;
      position: absolute;
      bottom: -9px;
      left: 340px;
      z-index: 9999;
      .ercode_img {
        width: 230px;
        height: 230px;
        margin-bottom: 38px;
      }
      .ercode_txt {
        font-size: 16px;
        color: #333333;
        p {
          margin-bottom: 10px;
          font-family: "SourceHanSansCN-Light", sans-serif;
          span {
            font-family: "SourceHanSansCN-Medium", sans-serif;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>